import { Box, Button, Typography } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router'
import CoachCampList from './List'

const CoachCamp = () => {
    const history = useHistory()
    const handleCreate = () => {
        history.push('/admin/coach-camp/create')
    }

    return <React.Fragment>
        <Box display="flex" justifyContent="space-between">
            <Box>
                <Typography variant="h6">训练营管理</Typography>
            </Box>
            <Box>
                <Button onClick={handleCreate}>创建训练营</Button>
            </Box>
        </Box>
        <Box mt={2}>
            <CoachCampList/>
        </Box>
    </React.Fragment>
}

export default CoachCamp